(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-marquee-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('somora-image-slider')) {
    class SomoraImageSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.track = this.querySelector(
          '.somora-image-slider__track'
        );

        this.viewport = this.querySelector(
          '.somora-image-slider__viewport'
        );

        if (!this.track || !this.viewport) return;

        this.originalItems = Array.from(
          this.track.querySelectorAll(
            '.somora-image-slider__item:not(.somora-image-slider__item--clone)'
          )
        );

        if (this.originalItems.length < 2) return;

        this.direction =
          this.dataset.direction === 'right' ? -1 : 1;

        this.cloneCount = Math.min(
          4,
          this.originalItems.length
        );

        this.currentIndex = this.cloneCount;
        this.isMoving = false;
        this.isPaused = false;

        this.reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.createClones();
        this.setPosition(false);

        this.handleTransitionEnd =
          this.handleTransitionEnd.bind(this);

        this.handleMouseEnter =
          this.pauseSlider.bind(this);

        this.handleMouseLeave =
          this.resumeSlider.bind(this);

        this.track.addEventListener(
          'transitionend',
          this.handleTransitionEnd
        );

        this.viewport.addEventListener(
          'mouseenter',
          this.handleMouseEnter
        );

        this.viewport.addEventListener(
          'mouseleave',
          this.handleMouseLeave
        );

        this.resizeObserver = new ResizeObserver(() => {
          this.isMoving = false;
          this.setPosition(false);

          if (
            !this.isPaused &&
            !this.reduceMotion
          ) {
            requestAnimationFrame(() => {
              this.moveNext();
            });
          }
        });

        this.resizeObserver.observe(this.viewport);

        if (!this.reduceMotion) {
          requestAnimationFrame(() => {
            this.moveNext();
          });
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.track) {
          this.track.removeEventListener(
            'transitionend',
            this.handleTransitionEnd
          );
        }

        if (this.viewport) {
          this.viewport.removeEventListener(
            'mouseenter',
            this.handleMouseEnter
          );

          this.viewport.removeEventListener(
            'mouseleave',
            this.handleMouseLeave
          );
        }
      }

      pauseSlider() {
  if (this.isPaused) return;

  this.isPaused = true;

  const computedStyle = window.getComputedStyle(this.track);
  const transform = computedStyle.transform;

  let currentX = 0;

  if (transform && transform !== 'none') {
    const matrix = new DOMMatrixReadOnly(transform);
    currentX = matrix.m41;
  }

  this.pausedTranslateX = currentX;

  this.track.style.transition = 'none';
  this.track.style.transform =
    `translate3d(${currentX}px, 0, 0)`;

  void this.track.offsetWidth;
}

      resumeSlider() {
  if (!this.isPaused) return;

  this.isPaused = false;

  const stepSize = this.getStepSize();

  if (!stepSize) return;

  const targetX =
    -this.currentIndex * stepSize;

  const currentX =
    Number(this.pausedTranslateX) || 0;

  const remainingDistance =
    Math.abs(targetX - currentX);

  const fullDuration =
    parseFloat(
      window
        .getComputedStyle(this)
        .getPropertyValue('--transition-duration')
    ) || 4000;

  
  const remainingDuration =
    Math.max(
      50,
      fullDuration *
        (remainingDistance / stepSize)
    );

  requestAnimationFrame(() => {
    this.track.style.transition =
      `transform ${remainingDuration}ms linear`;

    this.track.style.transform =
      `translate3d(${targetX}px, 0, 0)`;
  });
}

      createClones() {
        const firstItems =
          this.originalItems.slice(
            0,
            this.cloneCount
          );

        const lastItems =
          this.originalItems.slice(
            -this.cloneCount
          );

        const beforeFragment =
          document.createDocumentFragment();

        const afterFragment =
          document.createDocumentFragment();

        lastItems.forEach((item) => {
          beforeFragment.appendChild(
            this.cloneItem(item)
          );
        });

        firstItems.forEach((item) => {
          afterFragment.appendChild(
            this.cloneItem(item)
          );
        });

        this.track.insertBefore(
          beforeFragment,
          this.track.firstChild
        );

        this.track.appendChild(
          afterFragment
        );
      }

      cloneItem(item) {
        const clone = item.cloneNode(true);

        clone.classList.add(
          'somora-image-slider__item--clone'
        );

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        clone
          .querySelectorAll(
            'a, button, input, select, textarea'
          )
          .forEach((element) => {
            element.setAttribute(
              'tabindex',
              '-1'
            );
          });

        return clone;
      }

      getStepSize() {
        const firstItem =
          this.track.querySelector(
            '.somora-image-slider__item'
          );

        if (!firstItem) return 0;

        const trackStyles =
          window.getComputedStyle(this.track);

        const gap =
          parseFloat(
            trackStyles.columnGap ||
            trackStyles.gap
          ) || 0;

        return (
          firstItem.getBoundingClientRect().width +
          gap
        );
      }

      setPosition(animate = true) {
        const stepSize = this.getStepSize();

        if (!stepSize) return;

        if (!animate) {
          this.track.style.transition = 'none';
        } else {
          this.track.style.removeProperty(
            'transition'
          );
        }

        this.track.style.transform =
          `translate3d(${
            -this.currentIndex * stepSize
          }px, 0, 0)`;

        if (!animate) {
          void this.track.offsetWidth;

          this.track.style.removeProperty(
            'transition'
          );
        }
      }

      moveNext() {
        if (
          this.isMoving ||
          this.isPaused ||
          this.reduceMotion
        ) {
          return;
        }

        this.isMoving = true;
        this.currentIndex += this.direction;

        this.setPosition(true);
      }

      handleTransitionEnd(event) {
        if (
          event.target !== this.track ||
          event.propertyName !== 'transform'
        ) {
          return;
        }

          this.track.style.removeProperty('transition');


        const originalCount =
          this.originalItems.length;

        const firstOriginalIndex =
          this.cloneCount;

        const firstAfterCloneIndex =
          this.cloneCount + originalCount;

        if (
          this.currentIndex >=
          firstAfterCloneIndex
        ) {
          this.currentIndex =
            firstOriginalIndex;

          this.setPosition(false);
        } else if (
          this.currentIndex <
          firstOriginalIndex
        ) {
          this.currentIndex =
            firstOriginalIndex +
            originalCount -
            1;

          this.setPosition(false);
        }

        this.isMoving = false;

        if (!this.isPaused) {
          requestAnimationFrame(() => {
            this.moveNext();
          });
        }
      }
    }

    customElements.define(
      'somora-image-slider',
      SomoraImageSlider
    );
  }
  } catch(e) { console.error(e); }
})();

})();
